module.exports = __webpack_public_path__ + "img/core_03.0a26e550.png";